<div>
  @if (isStateNotAdded()) {
    <button (click)="addToCart()"
            class="!rounded-2xl w-full px-4 py-2 mb-4 !text-[var(--p-text-color-secondary)] bg-[var(--p-info-500)] hover:bg-[var(--p-info-600)] focus:bg-[var(--p-info-700)]">
      <div class="flex justify-between">
        <fa-icon [icon]="icons.faCartPlus" />
        <span>Add to Cart</span>
        <span class="w-4"><!-- empty on purpose to center button --></span>
      </div>
    </button>
  } @else if (isStateJustAdded() || isStateAlreadyAdded()) {
    <button class="!rounded-2xl w-full px-4 py-2 mb-4 !text-white bg-[var(--p-green-500)] hover:bg-[var(--p-green-600)] focus:bg-[var(--p-green-700)]"
            [routerLink]="['/auctions', this.auctionId(), 'checkout']">
      <div class="flex justify-between">
        <fa-icon [icon]="icons.faCheckCircle" />
        <span>Go to Checkout Now</span>
        <span class="w-4"><!-- empty on purpose to center button --></span>
      </div>
    </button>
  }
</div>
